import { createContext } from "react";

/**
 * Context of the contract that's being edited or added
 * @type {import("react").Context<import("./types").ContextContractI>}
 */
export const ContractContext = createContext();
